import CoachListContainer from "../../container/admin/coachList/coachListContainer";
import CoachListContext from "../../container/admin/coachList/context/coachListContext";

const CoachList = (): React.JSX.Element => (
  <CoachListContext>
    <CoachListContainer />
  </CoachListContext>
);

export default CoachList;
